export function LeadIcon() {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24Z'
        fill='#DAE4FF'
      />
      <g clipPath='url(#clip0_10232_50186)'>
        <path
          d='M28.4 16.3L30.6 18.5L35 14.1M35 21V29.72C35 31.5682 35 32.4923 34.6403 33.1982C34.3239 33.8191 33.8191 34.3239 33.1982 34.6403C32.4923 35 31.5682 35 29.72 35H18.28C16.4318 35 15.5077 35 14.8018 34.6403C14.1809 34.3239 13.6761 33.8191 13.3597 33.1982C13 32.4923 13 31.5682 13 29.72V18.28C13 16.4318 13 15.5077 13.3597 14.8018C13.6761 14.1809 14.1809 13.6761 14.8018 13.3597C15.5077 13 16.4318 13 18.28 13H26.5M13.1601 32.7189C13.6761 30.8625 15.3788 29.5 17.3997 29.5H25.0997C26.122 29.5 26.6331 29.5 27.0581 29.5845C28.8036 29.9317 30.168 31.2962 30.5152 33.0416C30.5997 33.4666 30.5997 33.9778 30.5997 35M26.2 21.25C26.2 23.6801 24.2301 25.65 21.8 25.65C19.3699 25.65 17.4 23.6801 17.4 21.25C17.4 18.8199 19.3699 16.85 21.8 16.85C24.2301 16.85 26.2 18.8199 26.2 21.25Z'
          stroke='#1047CA'
          strokeWidth='1.67'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_10232_50186'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(12 12)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
